<template>
  <v-dialog max-width="500" :value="dialog" @click:outside="close">
    <v-card class="align-center d-flex flex-column py-10 px-7">
      <CloseDialogButton :close="close" />
      <div class="font-size-lg font-weight-semibold mb-5">Change Password</div>
      <v-form ref="form" v-model="valid" class="full-width">
        <PasswordInput
          :label="'New Password (Min. 6 Characters)'"
          :password="password"
          :update="update"
        />
        <ConfirmPasswordInput
          :confirmPassword="confirmPassword"
          :label="'Confirm New Password (Min. 6 Characters)'"
          :password="password"
          :update="update"
        />
        <v-btn
          color="success"
          :disabled="!valid"
          @click.prevent="savePassword"
          block
          large
          rounded
        >
          <div class="font-size-md font-weight-semibold text-capitalize">
            save
          </div>
        </v-btn>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";
import ConfirmPasswordInput from "@/components/Inputs/ConfirmPassword.vue";
import PasswordInput from "@/components/Inputs/Password.vue";

export default {
  name: "EditPasswordDialog",
  components: { CloseDialogButton, ConfirmPasswordInput, PasswordInput },
  computed: {
    ...mapState({
      user: (state) => state.user.info,
    }),
  },
  data() {
    return {
      confirmPassword: null,
      password: null,
      valid: true,
    };
  },
  methods: {
    savePassword() {
      this.$refs.form.validate();
      if (!this.valid) {
        return;
      }
      this.password && this.save({ password: this.password });
      this.close();
    },
    update(name, val) {
      this[name] = val;
    },
  },
  props: {
    close: Function,
    dialog: Boolean,
    save: Function,
  },
};
</script>
